module.exports = __webpack_public_path__ + "static/media/krt01.f9080d85.png";